import { Action, createReducer, on } from '@ngrx/store';
import {
  fetchAirGroupResultsAction,
  fetchAirGroupResultsSuccessAction,
  fetchAirResultsAction,
  fetchAirResultsSuccessAction,
  searchFlightsForMobileErrorAction,
  searchFlightsForDesktopErrorAction,
  searchFlightsAction,
  disabledFlightScrollAction
} from '@flight-results/store/actions/flights-results.actions';
import { AirGroupResults, AirMobileResults } from '@app/entities/flight-results';

export const initialState = true;

const featureReducer = createReducer(
  initialState,
  on(
    searchFlightsAction,
    fetchAirResultsAction,
    searchFlightsForMobileErrorAction,
    fetchAirGroupResultsAction,
    searchFlightsForDesktopErrorAction,
    () => initialState
  ),
  on(disabledFlightScrollAction, (state, { payload }) => payload),
  on(fetchAirResultsSuccessAction, (state, { flightResults }) => 
    (flightResults.Results as AirMobileResults).AirResults.length === 0),
  on(fetchAirGroupResultsSuccessAction, (state, { flightResults }) => 
    (flightResults.Results as AirGroupResults).AirGroupedResults.length === 0),
);

export const disabledFlightScrollReducer = (state: boolean, action: Action): boolean => {
  return featureReducer(state, action);
};
